import VehicleDetailTitledSection from 'components/Vehicle/VehicleDetail/VehicleDetailTitledSection';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent, useEffect, useState } from 'react';

interface ExperienceDetailContactProps {
  wrapperClass?: string;
}

const ExperienceDetailContact: FunctionComponent<
  ExperienceDetailContactProps
> = ({ wrapperClass }) => {
  const { t } = useTranslation();
  const [link, setLink] = useState<string>('Teknevia');

  useEffect(() => {
    setLink(window?.location?.href);
  }, []);

  return (
    <VehicleDetailTitledSection
      title={t('experience:doYouHaveAQuestion.title')}
      className={wrapperClass}
      noHeading
    >
      <span>{t('experience:doYouHaveAQuestion.description')}</span>{' '}
      <a
        href={t('experience:doYouHaveAQuestion.link', { link })}
        target="doYouHaveAQuestion"
        rel="noreferrer nofollow"
        className="underline hover:no-underline"
      >
        {t('experience:doYouHaveAQuestion.action')}
      </a>
    </VehicleDetailTitledSection>
  );
};

export default ExperienceDetailContact;
